import store from '@/store/index.js'
import { makeRequest } from '@/libs/RequestModule'
import md5 from 'md5'
import { updateSonsAfterRecharge } from '@/components/controllers/RechargeController.js'
import { log } from '@/libs/Logger'

const getClients = async function () {
    const clients = (await makeRequest('getClients'))?.data
    return clients
}

const getStates = async function () {
    const payload = {
        NMESTADO: '%%'
    }
    const states = (await makeRequest('getStates', payload))?.data
    return states
}

const getCities = async function (data) {
    const payload = {
        SGESTADO: data.SGESTADO,
        NMMUNICIPIO: '%%',
        FIRST: 1,
        LAST: 1000
    }
    const cities = (await makeRequest('getCities', payload))?.data
    return cities
}

const checkConsumerByLogin = async function () {
    const data = store.getters.getPersonalData
    const payload = {
        CDCLIENTE: data.instituicao.CDCLIENTE,
        NMLOGINCONS: data.login
    }
    const consumer = (await makeRequest('checkConsumerByLogin', payload))?.data
    return consumer
}

const checkConsumerByCPF = async function () {
    const data = store.getters.getPersonalData
    const payload = {
        CDCLIENTE: data.instituicao.CDCLIENTE,
        NRCPFRESPCON: removeMask(data.cpf)
    }
    const result = (await makeRequest('checkConsumerByCPF', payload))?.data
    return result
}

const checkConsumerById = async function (CDCLIENTE = null, RA = null) {
    let payload = []
    if (!CDCLIENTE || !RA) {
        const dependentsData = store.getters.getDependentsData
        const CDCLIENTE = store.getters.getPersonalData.instituicao.CDCLIENTE
        dependentsData.forEach((e) => {
            payload.push({
                CDCLIENTE: CDCLIENTE,
                CDIDCONSUMID: e.ra
            })
        })
    } else {
        payload = [{
            CDCLIENTE: CDCLIENTE,
            CDIDCONSUMID: RA
        }]
    }
    const result = (await makeRequest('checkConsumerById', payload))?.data
    return result
}

const registerUser = async function () {
    const data = store.getters.getAllData
    const payload = {
        CDCLIENTE: data.personalData.instituicao.CDCLIENTE,
        CDFILIAL: data.personalData.instituicao.CDFILIAL,
        NMLOGINCONS: removeSpaces(data.personalData.login || data.personalData.nomedeusuario),
        CDSENHACONSMD5: encrypt(data.personalData.senha),
        NMRESPCONS: removeSpaces(data.personalData.nome),
        NRCPFRESPCON: removeMask(data.personalData.cpf),
        DSEMAILCONS: removeSpaces(data.personalData.email),
        NRTELECONS: null,
        NRCELULARCONS: removeMask(data.personalData.celular),
        DSENDECONS: removeSpaces(data.addressData.endereco),
        NRENDECONS: removeSpaces(data.addressData.numero),
        DSCOMPLENDECONS: data.addressData.complemento ? removeSpaces(data.addressData.complemento) : null,
        DSREFERENDECONS: data.addressData.referencia ? removeSpaces(data.addressData.referencia) : null,
        NRCEPCONS: removeMask(data.addressData.cep),
        CDPAIS: data.addressData.CDPAIS,
        SGESTADO: data.addressData.uf.SGESTADO,
        CDMUNICIPIO: data.addressData.municipio.CDMUNICIPIO,
        NMBAIRCONS: data.addressData.bairro || null,
        sonsData: buildDependentsData()
    }

    const result = (await makeRequest('registerUser', payload))?.data
    return result
}

const registerDependents = async function (dependent) {
    const dependentParams = {
        CDIDCONSUMID: dependent.ra.trim(),
        NMCONSUMIDOR: dependent.nome.trim()
    }
    makeRequest('addDependents', dependentParams)
        .then(response => {
            if (response?.sucesso) {
                updateSonsAfterRecharge()
            } else {
                log({ type: 'error', message: response?.message })
            }
        })
        .catch(error => {
            log({ type: 'error', message: error?.message })
        })
        .finally(() => {
            store.dispatch('stopLoading')
        })
}

function buildDependentsData () {
    const dependentsData = store.getters.getDependentsData
    const dependents = []
    dependentsData.forEach(element => {
        const dependent = {
            CDIDCONSUMID: element.ra?.trim() || '',
            NMCONSUMIDOR: element.nome.trim()
        }
        dependents.push(dependent)
    })
    return dependents
}

function removeMask (value) {
    return value.toString().replace(/[^0-9]+/g, '')
}

function removeSpaces (value) {
    return value && typeof value === 'string' ? value.trim() : value
}

function encrypt (value) {
    return md5(`odhen${value}7833`)
}

export { getClients, getStates, getCities, registerUser, checkConsumerByLogin, checkConsumerByCPF, checkConsumerById, registerDependents }
